import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from "../../../../../core/services/mono-occurrence.service";
import { IComponentController } from "angular";

interface IPageDo0022 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaireSom: IFormulaire;
}

/* @ngInject */
export default function Al2000Controller(
    Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItem: IFormulaireItemClass) {
    const vm: IPageDo0022 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    
    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false,
            exportation: false
        }
    }
    vm.formulaireSom = new Formulaire(' ',[
            new FormulaireItem('posnumdoc',{
                default:vm.valeursEcran.posnumdoc,
                largeur:33
            }),
            new FormulaireItem('posdsc',{
                default:vm.valeursEcran.posdsc,
                largeur:66
            }),
            new FormulaireItem('posdscfon',{
                enableCount:true,
                largeur:100
            })
        ]);
    }
